module.exports = __webpack_public_path__ + "images/ew-square.79295520.png";